/** @jsx jsx */
import { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { jsx, css } from '@emotion/core'
import { reduxForm, Field } from 'redux-form'
import { userList } from '../actions/user'
import InputField from './InputField'
import DefaultButton from './DefaultButton'
import BusyMask from './BusyMask'
import { Button } from 'react-bootstrap'
import { default_theme as theme } from '../emotion/theme'

const required = value => value ? undefined : 'Required'

class EmailForm extends Component {

    componentDidMount() {
        const { dispatch, user } = this.props
        dispatch(userList.ensureObjectLoaded(user.id))
    }

    render() {
        const { handleSubmit, onCancelEmail, onRequestToken, error, new_email, is_busy } = this.props

        const otp_label = "Send OTP to: " + new_email
        
        return (
            <form css={ form_layout } onSubmit={ handleSubmit }>
              { is_busy && <BusyMask /> }
              <div className="form-group" css={ field_container }>
                <Button onClick={ onRequestToken }>
                  {otp_label}
                </Button>
              </div>
              <div className="form-group" css={ field_container }>
                <label css={ label }>Enter OTP</label>
                <div>
                  <Field
                      type="text"
                      name="otp"
                      validate={[required]}
                      component={ InputField }
                  />
                </div>
              </div>
              <div css={ footer }>
                <div>
                  <DefaultButton
                      label="Cancel"
                      type="button"
                      onClickButton={ onCancelEmail }
                  />
                </div>
                <div css={ error_container }>
                  { error && <p>{ error }</p>}
                </div>
                <div>
                  <Button type="submit">
                    Save
                  </Button>
                </div>
              </div>
            </form>
        )
    }
}
EmailForm = reduxForm({
    form: 'EMAIL_FORM'
})(EmailForm);
function mapStateToProps(state, props) {
    const { onSubmit, onRequestToken, onCancelEmail, user_id } = props
    const user = userList.getObject(user_id) || {}
    return {
        onSubmit,
        onRequestToken,
        onCancelEmail,
        user,
        initialValues: user,
        enableReinitialize: true,
        is_busy: userList.isLoading()
    }
}
export default withRouter(connect(mapStateToProps)(EmailForm))

const form_layout = css`
width: 100%;
display: flex;
flex-direction: column;
align-items: center;
padding-top: 20px;
`

const field_container = css`
width: 90%;
display: flex;
flex-direction: column;
`

const error_container = css`
p {
color: ${theme.colors.error};
}
`

const footer = css`
display: flex;
flex-direction: row;
align-items: center;
justify-content: space-between;
width: 90%;
padding-top:20px;
padding-bottom:20px;
`

const label = css`
color: ${theme.colors.secondary};
font-weight: 600;
`
